module.exports = __webpack_public_path__ + "media/your_career_track/construction-manager-e5a49083.png";